// Casa Libre design-system tokens — single source of truth for inline styles.
// See Casa-Libre-Admin-Portal-Design-System.md §10.3.
export const T = {
  primary: '#111111', primarySurface: '#F1ECE2',
  textPrimary: '#111111', textBody: '#3A3A37', textSecondary: '#6B6862', textMuted: '#9C978C',
  bgWhite: '#FFFFFF', bgSurface: '#FAF7F1', paper: '#F9F4EE', borderLight: '#E7E1D6',
  success: '#0F6E56', successSurface: '#E4F1E9',
  warning: '#8A5A12', warningSurface: '#F5EAD5',
  info: '#2A5B8A', infoSurface: '#E1ECF5',
  danger: '#B23A3A', dangerSurface: '#F6E4E1',
};

export const CARD = { border: `1px solid ${T.borderLight}`, borderRadius: '14px', background: T.bgWhite };

export const selectStyle = {
  border: `1px solid ${T.borderLight}`, borderRadius: '999px', color: T.textBody,
  background: T.bgWhite, fontSize: '12px', padding: '6px 12px', outline: 'none',
};

// Categorical chart palette (pie/donut/multi-series), in order.
export const PIE_COLORS = ['#111111', '#0F6E56', '#2F6DB4', '#B4531A', '#7A3E8E', '#C23B3B', '#3C8C7A', '#8A6D12'];

// Hard offset shadows (no blur).
export const SHADOW = {
  hard: '5px 5px 0 #111111',
  hardSm: '4px 4px 0 #111111',
  hardSoft: '4px 4px 0 rgba(17,17,17,.2)',
};
